export default {
    "affiliation": "good",
    "party": {
        "units": {
            "oriana": {
                "key": "oriana",
                "jobKey": "hero/swordlord",
                "affiliation": "good",

                "isRecruited": true,

                "maxhealth": 40,
                "unlockedSkills": [],

                "name": "Oriana",
                "subtitle": "Lord",

                "sprites": require("@frog/source/assets/images/hero-tactics-ii/units/ally/lord").default,
                "portraits": {
                    // "neutral": require("@frog/source/assets/images/chess-tactics/portraits/newer/RP-neutral.png"),
                    "neutral": require("@frog/source/assets/images/chess-tactics/portraits/newer/RP-neutral2.png"),
                    "angry": require("@frog/source/assets/images/chess-tactics/portraits/newer/RP-angry.png"),
                    "happy": require("@frog/source/assets/images/chess-tactics/portraits/newer/RP-happy.png"),
                },

                "level": 1,
                "maxexperience": 50,
                "levelups": {
                    2: [
                        {"key": "maxhealth", "value": 10},
                        {"key": "maxexperience", "value": 50},
                        {"key": "skill", "value": "push"},
                    ],
                    3: [
                        {"key": "maxhealth", "value": 10},
                        {"key": "maxexperience", "value": 50},
                        {
                            "key": "jobKeys",
                            "values": [
                                "hero/bladesinger",
                                "hero/firefist"
                            ]
                        },
                    ],
                    4: [
                        {"key": "maxhealth", "value": 10},
                        {"key": "maxexperience", "value": 50},
                    ],
                },

                // "level": 3,
                // "maxhealth": 60,
                // "jobKey": "hero/bladesinger",
                // "sprites": require("@frog/source/assets/images/hero-tactics-ii/units/ally/bladesinger").default,
                // "skills": [
                //     "inflict-damage",
                //     "rally"
                // ]
            },
            "brigid": {
                "key": "brigid",
                "jobKey": "hero/archer",
                "affiliation": "good",

                "isRecruited": true,

                "maxhealth": 40,
                "unlockedSkills": [],

                "name": "Brigid",
                "subtitle": "Archer",

                "imageUrl": null,
                "sprites": require("@frog/source/assets/images/hero-tactics-ii/units/ally/archer").default,
                "portraits": {
                    "neutral": require("@frog/source/assets/images/chess-tactics/portraits/newer/P-neutral.png"),
                    "happy": require("@frog/source/assets/images/chess-tactics/portraits/newer/P-happy.png"),
                    "frowny": require("@frog/source/assets/images/chess-tactics/portraits/newer/P-frowny.png"),
                },

                "level": 1,
                "maxexperience": 50,
                "levelups": {
                    2: [
                        {"key": "maxhealth", "value": 10},
                        {"key": "maxexperience", "value": 50},
                        {"key": "skill", "value": "pull"},
                    ],
                    3: [
                        {"key": "maxhealth", "value": 10},
                        {"key": "maxexperience", "value": 50},
                        {
                            "key": "jobKeys",
                            "values": [
                                "hero/sniper",
                                "hero/ranger"
                            ]
                        },
                    ],
                    4: [
                        {"key": "maxhealth", "value": 10},
                        {"key": "maxexperience", "value": 50},
                        {"key": "skill", "value": "suplex"}
                    ],
                },

                // "level": 3,
                // "maxhealth": 50,
                // "jobKey": "hero/ranger",
                // "sprites": require("@frog/source/assets/images/hero-tactics-ii/units/ally/ranger").default,
                // "skills": [
                //     "inflict-damage",
                //     "pull"
                // ]
            },
            "callista": {
                "key": "callista",
                "jobKey": "hero/knight",
                "affiliation": "good",

                "isRecruited": true,

                "maxhealth": 50,
                "moverange": 2,
                "power": 30,
                "unlockedSkills": [
                    "restore-health"
                ],

                "name": "Callista",
                "subtitle": "Knight",

                "sprites": require("@frog/source/assets/images/hero-tactics-ii/units/ally/knight").default,
                "portraits": {
                    "neutral": require("@frog/source/assets/images/chess-tactics/portraits/newer/R-neutral.png"),
                    "happy": require("@frog/source/assets/images/chess-tactics/portraits/newer/R-happy.png"),
                    "confused": require("@frog/source/assets/images/chess-tactics/portraits/newer/R-confused.png"),
                    "stern": require("@frog/source/assets/images/chess-tactics/portraits/newer/R-stern.png"),
                },

                "level": 2,
                "maxexperience": 50,
                "levelups": {
                    // 2: [
                    //     {"key": "maxhealth", "value": 10},
                    //     {"key": "maxexperience", "value": 50},
                    //     {"key": "skill", "value": "restore-health"},
                    // ],
                    3: [
                        {"key": "maxhealth", "value": 10},
                        {"key": "maxexperience", "value": 50},
                        {
                            "key": "jobKeys",
                            "values": [
                                "hero/general",
                                "hero/paladin"
                            ]
                        },
                    ],
                    4: [
                        {"key": "maxhealth", "value": 10},
                        {"key": "maxexperience", "value": 50},
                        {"key": "skill", "value": "pivot"}
                    ],
                },

                // "level": 3,
                // "jobKey": "hero/general",
                // "maxhealth": 60,
                // "sprites": require("@frog/source/assets/images/hero-tactics-ii/units/ally/general").default,
            },
        }
    }
}
